import * as React from 'react';

import { Button } from '../../components/buttons';
import { TextInput } from '../../components/forms';
import { IconAdd } from '../../components/icons';

interface Props {
	addStaff: () => void;
	searchterm: string;
	onSearch: (e: any) => void;
}
const StaffListOptions: React.StatelessComponent<Props> = props => {
	return (
		<div className="table-options">
			<div className="btn-group table-filters">
				<div className="table-filter">
					<Button
						className="btn-outline-primary"
						onClick={props.addStaff}
					>
						<span className="align-middle mx-2">Add a staff</span>
						<IconAdd />
					</Button>
				</div>
			</div>
			<TextInput
				name="search"
				placeholder="Search"
				value={props.searchterm}
				onChange={props.onSearch}
				className="m-0 table-search"
			/>
		</div>
	);
};

export default StaffListOptions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/staff/StaffListOptions.tsx